import axios from 'axios';
// import { useIntl } from 'react-intl';
import { toast } from 'react-toastify';

// export const useCustomIntl = () =>
// {
// 	const intl = useIntl();

// 	return intl;
// };

export const OverLapMeetings = async (startTime, endTime, licenseId, userId, query) =>
{
	console.log('query/////////////', query);
	try
	{
		const token = await window?.electron?.ipcRenderer?.invoke('getRoomData', 'token');

		if (token)
		{
			const url = `/schedule/overlapmeetings/${startTime}/${endTime}/${licenseId}/${userId}${query ? query : ''}`;

			let apiQuery;

			if (query)
			{
				apiQuery = query;
			}
			// 'newUserId=e1b33d0a-9061-7056-2a6c-6b647c6fa0b6'
			const data = JSON.stringify({
				'path'   : url,
				'method' : 'GET'
				// 'apiQuery' : query
			});
			const config = {
				method        : 'post',
				maxBodyLength : Infinity,
				url           : import.meta.env.VITE_S3_AUTH_MYFILES_API,
				headers       : {
					'Authorization' : `Bearer ${token}`,
					'Content-Type'  : 'application/json'
				},
				data : data
			};

			const response = await axios.request(config);

			return response.data;
		}
		else
		{
			toast.dismiss();
			toast.error('Controller pairing failed. Please pair it again!');

			// eslint-disable-next-line react-hooks/rules-of-hooks
			// toast.error(useCustomIntl().formatMessage({ id: 'Controller_pairing_failed', defaultMessage: 'Controller pairing failed. Please pair it again!' }));

		}

	}
	catch (error)
	{
		console.log('Error occurred while fetching data:', error);
		throw error;
	}
};

export default OverLapMeetings;
